import React, { useState, useEffect, useRef } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx";
import Globales from "utils/Globales";
import Slider from "react-animated-slider";
import "../../../Styles/react-animated-slider/horizontal.css";
import "../../../Styles/react-animated-slider/slider-animations.css";
import "../../../Styles/react-animated-slider/styles.css";
import "../../../Styles/react-animated-slider/responsive.css";

import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";

const MOBILE_BREAKPOINT = 768;

function BannerInicio(props) {
	const { classes, dropdownHoverColor } = props;
	const { isAuthenticated, loginWithRedirect } = useAuth0();
	const [auth, setAuth] = useState(null);
	const [isMobile, setIsMobile] = useState(false);
	const lastScrollYRef = useRef(0);

	// Detectar móvil para mostrar banner estático en lugar de carrusel
	useEffect(() => {
		const check = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
		check();
		window.addEventListener("resize", check);
		return () => window.removeEventListener("resize", check);
	}, []);

	// Guardar posición de scroll y en móvil restaurar si algo provoca un salto (solo si se usara carrusel)
	useEffect(() => {
		if (isMobile) return;
		const y = () => window.scrollY ?? window.pageYOffset;
		let prevY = y();
		const handleScroll = () => {
			const currentY = y();
			lastScrollYRef.current = currentY;
			if (prevY > 80 && currentY < 20) {
				requestAnimationFrame(() => window.scrollTo(0, prevY));
			}
			prevY = currentY;
		};
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, [isMobile]);

	const handleSlideChange = () => {
		const savedY = lastScrollYRef.current;
		const restore = () => {
			window.scrollTo(0, savedY);
			if (document.activeElement && document.activeElement !== document.body) {
				document.activeElement.blur();
			}
		};
		restore();
		requestAnimationFrame(restore);
		[50, 150, 300].forEach((ms) => setTimeout(restore, ms));
	};

	const IniciarSesion = (Referencia) => {
		let sesion = Cookies.get("UsuarioTerco");

		if (sesion && JSON.parse(sesion).id != "") {
			window.location.href = Referencia;
		} else {
			loginWithRedirect({
				authorizationParams: { prompt: "select_account" },
			});
		}
	};

	const properties = {
		//duration: 5000,
		transitionDuration: 500,
		infinite: true,
		indicators: true,
		arrows: true,
		autoplay: 5000,
		onSlideChange: handleSlideChange,
	};

	const content = [
		{
			image: Globales.Url + "Seccion1/jersey.jpg",
			title: "Personaliza tus Jerseys",
			description: "Agrega tu diseño, texto, stickers y mucho más...",
			button: "Empieza ya",
			referencia: "/SeleccionaTuDiseño",
		},
		{
			image: Globales.Url + "Seccion1/tshirt.jpg",
			title: "Miles de diseños a elegir",
			description: "Contamos con librería en línea de más de 2,000 diseños",
			button: "Personaliza la tuya",
			referencia: "/SeleccionaTuDiseño",
		},
		{
			image: Globales.Url + "Seccion1/artistas.jpg",
			title: "Diseña y vende",
			description:
				"Comecializa tus creaciones únicas y personalizadas a tus clientes",
			button: "Diseña la tuya",
			referencia: "/SeleccionaTuDiseño",
		},
	];

	// En móvil: banner en dos bloques (imagen arriba + texto abajo), estilos en CSS
		if (isMobile) {
		const item = content[0];
		return (
			<div id={props.id} style={{ background: "#000", minHeight: "100vh" }}>
			<div className="banner-mobile-static">
				<div
					className="banner-mobile-static__image"
					style={{ backgroundImage: `url('${item.image}')` }}
				>
					<div className="banner-mobile-static__overlay" />
				</div>
				<div className="banner-mobile-static__text">
					{item.title && <h1>{item.title}</h1>}
					<p>{item.description}{item.descriptionBold ? <strong>{item.descriptionBold}</strong> : null}</p>
					{item.description2 && <p>{item.description2}</p>}
					<button
						type="button"
						onClick={() => IniciarSesion(item.referencia)}
					>
						{item.button}
					</button>
				</div>
			</div>
			</div>
		);
	}

	return (
		<div id={props.id} style={{ background: "#000", minHeight: "100vh" }}>
		<Slider
			{...properties}
			style={{ height: "100vh" }}
			className="slider-custom"
		>
			{content.map((item, index) => (
				<div
					key={index}
					className="slider-content"
					style={{
						background: `url('${item.image}') no-repeat center center`,
						backgroundSize: "cover",
					}}
				>
					<div className="inner text-shadow-title">
						<h1 style={{ color: "rgb(7, 7, 7)" }}>
							{item.title}
						</h1>
						<p className="text-shadow-description" style={{ color: "rgb(7, 7, 7)" }}>
							{item.description}
							{item.descriptionBold ? <strong>{item.descriptionBold}</strong> : null}
						</p>
						<button
							type="button"
							tabIndex={-1}
							onClick={() => IniciarSesion(item.referencia)}
						>
							{item.button}
						</button>
					</div>
				</div>
			))}
		</Slider>
		</div>
	);
}

export default withStyles(headersStyle)(BannerInicio);
